import { APP_STORE_URL } from '../../constants/links';

type AppStoreButtonProps = {
  url?: string;
  className?: string;
};

export default function AppStoreButton({
  url = APP_STORE_URL,
  className = '',
}: AppStoreButtonProps) {
  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className={`flex items-center justify-center gap-3 px-5 py-3 bg-black text-white rounded-lg font-semibold hover:bg-gray-900 shadow-lg hover:shadow-xl transition-all ${className}`}>
      <svg
        className="w-12 h-12"
        viewBox="0 0 24 24"
        fill="currentColor">
        <path d="M17.05 20.28c-.98.95-2.05.88-3.08.4-1.09-.5-2.08-.48-3.24 0-1.44.62-2.2.44-3.08-.4C1.79 15.25 2.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.54 4.09l.01-.01zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z" />
      </svg>
      <div className="flex flex-col items-start">
        <span className="text-base leading-tight">Download on the</span>
        <span className="text-xl leading-tight">App Store</span>
      </div>
    </a>
  );
}

